// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1DdSo","icon":"SortAdornment_icon__1rMu3","up":"SortAdornment_up__18jkV","down":"SortAdornment_down__JjQgc","active":"SortAdornment_active__329II"};